import { create } from 'zustand';

const useUserStore = create((set, get) => ({
  user: null,
  
  setUser: (user) => set({ user }),
  
  updateUser: (updates) => set((state) => ({
    user: state.user ? { ...state.user, ...updates } : null
  })),
  
  updateAvatar: (avatarUrl) => set((state) => ({
    user: state.user ? { ...state.user, avatar_url: avatarUrl } : null
  })),
  
  updateBio: (bio) => set((state) => ({
    user: state.user ? { ...state.user, bio } : null
  })),
  
  clearUser: () => set({ user: null })
}));

export default useUserStore;